// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2ZcSd","disabled":"FileBtn_disabled__1d9-w","warn":"FileBtn_warn__34C1M","fade":"FileBtn_fade__w2Z83"};